import * as React from "react";
import { Mirror } from "../components/Mirror";
import { useCallbackRef } from "./useRef";
export function useMirror(props) {
    const [node, ref] = useCallbackRef();
    return [ref, React.createElement(Mirror, Object.assign({ key: "mirror" }, props, { reflect: node }))];
}
